import { Component, Vue } from "vue-property-decorator";

@Component<BlankPage>({
  components: {}
})
export default class BlankPage extends Vue {}
